import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMagicWand02Filled = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M16 2C16 1.44772 15.5523 1 15 1C14.4477 1 14 1.44772 14 2V4C14 4.55228 14.4477 5 15 5C15.5523 5 16 4.55228 16 4V2Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16 14C16 13.4477 15.5523 13 15 13C14.4477 13 14 13.4477 14 14V16C14 16.5523 14.4477 17 15 17C15.5523 17 16 16.5523 16 16V14Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7 9C7 8.44772 7.44772 8 8 8H10C10.5523 8 11 8.44772 11 9C11 9.55229 10.5523 10 10 10H8C7.44772 10 7 9.55229 7 9Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20 8C19.4477 8 19 8.44772 19 9C19 9.55229 19.4477 10 20 10H22C22.5523 10 23 9.55229 23 9C23 8.44772 22.5523 8 22 8H20Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.0929 11.0927C17.4835 10.7022 18.1166 10.7022 18.5072 11.0927L19.7072 12.2927C20.0977 12.6832 20.0977 13.3164 19.7072 13.7069C19.3166 14.0974 18.6835 14.0974 18.2929 13.7069L17.0929 12.5069C16.7024 12.1164 16.7024 11.4832 17.0929 11.0927Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.7072 5.70711C20.0977 5.31658 20.0977 4.68342 19.7072 4.29289C19.3166 3.90237 18.6835 3.90237 18.2929 4.29289L17.0929 5.49289C16.7024 5.88342 16.7024 6.51658 17.0929 6.90711C17.4835 7.29763 18.1166 7.29763 18.5072 6.90711L19.7072 5.70711Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.2929 4.29289C10.6834 3.90237 11.3166 3.90237 11.7071 4.29289L12.9071 5.49289C13.2976 5.88342 13.2976 6.51658 12.9071 6.90711C12.5166 7.29763 11.8834 7.29763 11.4929 6.90711L10.2929 5.70711C9.90237 5.31658 9.90237 4.68342 10.2929 4.29289Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.7071 12.7071C13.0976 12.3166 13.0976 11.6834 12.7071 11.2929C12.3166 10.9024 11.6834 10.9024 11.2929 11.2929L2.29289 20.2929C1.90237 20.6834 1.90237 21.3166 2.29289 21.7071C2.68342 22.0976 3.31658 22.0976 3.70711 21.7071L12.7071 12.7071Z",
			fill: "currentColor"
		})
	]
});
export default SvgMagicWand02Filled;
